import { Component, Inject, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { Response } from 'express';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  constructor(
    public app: AppService,
    public route: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(RESPONSE) private responseExpress: Response
  ) { }

  ngOnInit(): void {
    if (isPlatformServer(this.platformId) && this.responseExpress) {
      let Lcode = this?.route?.url?.includes('/en/') ? 'en' : 'ar'
      const urlRedirectTo = `/${encodeURIComponent(Lcode)}/home`;
      this.responseExpress.set('location', urlRedirectTo);
      this.responseExpress.setHeader('Content-Type', 'text/plain');
      this.responseExpress.statusCode = 301;
      return
      // this.responseExpress.statusCode = 404;
      // const urlRedirectTo = `/404`;
      // this.responseExpress.set('location', urlRedirectTo);
      // this.responseExpress.setHeader('Content-Type', 'text/plain');
      // this.responseExpress.statusCode = 404;
    }

  }

}
